import { render } from "./validityTime.vue?vue&type=template&id=4e97e8a5"
import script from "./validityTime.vue?vue&type=script&lang=js"
export * from "./validityTime.vue?vue&type=script&lang=js"

import "./validityTime.vue?vue&type=style&index=0&id=4e97e8a5&lang=less"

import exportComponent from "D:\\codeDevelopment\\文稿通\\wgt_user_web_2.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__